import { HttpClient, HttpHeaders } from "@angular/common/http";
import { TranslateLoader } from "@ngx-translate/core";
import { environment } from "environments/environment";
import { CookieService } from "ngx-cookie";
import { map, Observable, tap } from "rxjs";
import { HTTPService } from "./http.service";
import { Injectable } from "@angular/core";
import { upperCase } from 'lodash';

@Injectable()
export class CustomTranslateLoader implements TranslateLoader {
    constructor(private http: HttpClient, private httpService: HTTPService) { }

    getTranslation(lang: string): Observable<any> {
        const url = `${environment.api_base_url}/localization/getJson/${upperCase(lang || 'en')}`;

        return this.http.get(url).pipe(map((res: any) => {
            console.log("====>>", res);
            return res.response;
        }));

    }
}